import { defineGameCard, onDeath } from '../authoring/index.js';
import { deathController, liveOpposingEnemy } from './furniture_helpers.js';
export const FallingDoorCard = defineGameCard({
    id: 'falling_door',
    gameplay: { type: 'STRUCTURE', cost: 2, baseStats: { attack: 0, health: 3 } },
    presentation: {
        name: 'Падающая дверь',
        description: 'После гибели наносит 4 урона вражеской карте напротив, если она ещё на поле.',
        glyph: {
            colors: ['#10213A', '#BC4739', '#7E2B2B', '#C9583F', '#A73830'],
            rows: [
                '........111.........',
                '.......1222111......',
                '.......1234222111...',
                '.......12222332221..',
                '......123255522221..',
                '......123555555531..',
                '......122555553531..',
                '.....122233555251...',
                '.....124222243531...',
                '.....125233224531...',
                '....142255223431....',
                '....123555555531....',
                '....153555553531....',
                '....15255555351.....',
                '...155553355551.....',
                '....11555553531.....',
                '......111155531.....',
                '..1111....1111......',
                '...11111111111111...',
                '.....11111111.......',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onDeath((ctx, event) => {
            const controllerId = deathController(ctx, event);
            if (controllerId === undefined)
                return;
            const opposite = liveOpposingEnemy(ctx, event.cellId, controllerId);
            if (opposite !== undefined) {
                ctx.ops.dealDamage({ kind: 'unit', instanceId: opposite.id }, 4);
            }
        }),
    ],
    ui: { mechanics: ['death'] },
});
//# sourceMappingURL=falling_door.js.map